import { render, staticRenderFns } from "./CorregirSolicitud.vue?vue&type=template&id=06a9e13d&"
import script from "./CorregirSolicitud.vue?vue&type=script&lang=js&"
export * from "./CorregirSolicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports